import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { Filter, Download } from "react-feather";
import { Dropdown, Spinner } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import axios from "axios";
import { baseurl } from "../../Baseurl";

const AllCustomerOTP = () => {
  const [otps, setOtps] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOtps = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllCustomerOtps`);
        console.log("OTP Response:", response);
        if (response.data.message === "Customer OTPs fetched successfully.") {
          setOtps(response.data.otps);
          setFilteredData(response.data.otps);
        }
      } catch (error) {
        console.error("Error fetching customer OTPs", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOtps();
  }, []);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "80px",
    },
    {
      name: "Email",
      selector: (row) => row.email || "-",
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone || "-",
      sortable: true,
    },
    {
      name: "OTP",
      selector: (row) => row.otp,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (row.status ? "Verified" : "Pending"),
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
  ];

  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Customer OTPs");
    XLSX.writeFile(wb, "customer_otps.xlsx");
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">All Customer OTPs</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search by Phone or Email"
                onChange={(e) =>
                  setFilteredData(
                    otps.filter((item) =>
                      `${item.phone || ""} ${item.email || ""}`
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                    )
                  )
                }
              />
              <Dropdown className="me-2">
                <Dropdown.Toggle className="form-control prwcl" id="dropdown-basic">
                  <Filter size={16} /> Status Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilteredData(otps)}>All</Dropdown.Item>
                  <Dropdown.Item onClick={() => setFilteredData(otps.filter(o => o.status))}>Verified</Dropdown.Item>
                  <Dropdown.Item onClick={() => setFilteredData(otps.filter(o => !o.status))}>Pending</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <span className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} />&nbsp;Download
              </span>
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: 0 }}>
              <div style={{ overflowX: "auto",  }}>
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    responsive
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllCustomerOTP;
